var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoldericon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph:folder-thin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M110.531 38.8906H66.3495L51.7706 24.3169C51.2026 23.7442 50.5265 23.2901 49.7816 22.9809C49.0367 22.6717 48.2378 22.5135 47.4312 22.5156H20.4688C18.8402 22.5156 17.2783 23.1626 16.1267 24.3142C14.9751 25.4658 14.3281 27.0277 14.3281 28.6563V102.661C14.3308 104.205 14.9452 105.684 16.0367 106.776C17.1282 107.867 18.6079 108.482 20.1515 108.484H110.987C112.494 108.483 113.939 107.884 115.005 106.818C116.071 105.752 116.671 104.307 116.672 102.799V45.0313C116.672 43.4027 116.025 41.8408 114.873 40.6892C113.722 39.5376 112.16 38.8906 110.531 38.8906ZM18.4219 28.6563C18.4219 28.1134 18.6375 27.5928 19.0214 27.2089C19.4053 26.825 19.9259 26.6094 20.4688 26.6094H47.4312C47.9725 26.6103 48.4913 26.8256 48.8743 27.2081L60.5568 38.8906H18.4219V28.6563ZM112.578 102.799C112.577 103.221 112.409 103.625 112.111 103.923C111.812 104.221 111.408 104.389 110.987 104.391H20.1515C19.6932 104.389 19.254 104.207 18.93 103.883C18.6059 103.558 18.4232 103.119 18.4219 102.661V42.9844H110.531C111.074 42.9844 111.595 43.2 111.979 43.5839C112.362 43.9678 112.578 44.4884 112.578 45.0313V102.799Z",
    fill: "#1b7d78"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 255",
    x: 18,
    y: 43,
    width: 95,
    height: 62,
    rx: 1,
    fill: "#1b7d7833"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 256",
    d: "M18 27C18 26.4477 18.4477 26 19 26H48.6433C48.9093 26 49.1643 26.106 49.352 26.2945L62 39H19C18.4477 39 18 38.5523 18 38V27Z",
    fill: "#1b7d7833"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoldericon);
export default __webpack_public_path__ + "static/media/folder icon.bd522a2721cf45f509ac0243914100f6.svg";
export { ForwardRef as ReactComponent };